import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'lib-html-text',
  templateUrl: './html-text.component.html',
  styleUrls: ['./html-text.component.scss']
})
export class HtmlTextComponent implements OnInit {

  @Input() text!: string;

  public config = {
    toolbar: [],
    disableResizeEditor: true,
    disableDragAndDrop: true
  }
  
  ngOnInit() {
    //const btnInfo = "<button style='border: 0px !important; background: transparent !important;' class='btn-only-icon btn-initial btn-question-info' type='button' data-toggle='offcanvas' data-target='#inspectionOffcanvasRight' aria-controls='offcanvasRight'><img src='assets/icons/infoOutlined.svg' /></button>";
    //this.text = "<div style='width: 100% !important; display: flex !important; align-items: center !important;'><div class='question'>" + this.text +'</div>' + btnInfo + "</div>"
    //this.text = "<div class='question'>" + this.text + "</div>";
  }
}
